<template>
    <div class="w-100">
        <div class="card">
            <div class="card-header bg-primary text-white">
                <page-title :title="$t('sideMenu.localization')" :showTitle="true"></page-title>
            </div>
        </div>

        <div class="card-body">
            <Localization></Localization>
        </div>
    </div>
</template>

<script>
    import Localization from '../../components/administration/LocalizationDetails'
    import PageTitle from '../../components/common/PageTitle';


    export default {
        components: {
            Localization,
            PageTitle
        },
        data() {
            return {
            };
        },
        methods: {

        },
        computed: {
           
        },
        mounted() {
           
        }
    };
</script>

<style>
</style>
